var _style, _desc, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoveryavas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A12885;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Cards/YaVas/Hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 40,
    cy: 40,
    r: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.3,40.3 9,32.2 12.9,32.2 15.9,37.5 19,32.2 22.7,32.2 17.4,40.3 17.4,46.3 14.3,46.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,32.2h2.6l6.1,14.1H31l-1.2-3h-5.5l-1.2,3h-3.4L25.8,32.2z M27,36.3l-1.7,4.4h3.4L27,36.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.4,32.2 38.9,32.2 42.4,41.5 42.4,41.5 46,32.2 49.3,32.2 43.5,46.3 41,46.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,32.2h2.6l6.1,14.1h-3.5l-1.2-3h-5.5l-1.2,3h-3.4L52.4,32.2z M53.6,36.3l-1.7,4.4h3.4L53.6,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.9,35.9c-0.5-0.6-1.4-0.9-2.1-0.9c-0.8,0-2,0.4-2,1.4c0,2.4,6.2,0.9,6.2,5.6c0,3-2.4,4.4-5.2,4.4 c-1.7,0-3.2-0.5-4.5-1.7l2.1-2.3c0.6,0.8,1.6,1.3,2.6,1.3c1,0,2-0.5,2-1.4c0-2.5-6.3-1.1-6.3-5.6c0-2.9,2.5-4.3,5.1-4.3 c1.5,0,3,0.4,4.1,1.4L68.9,35.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoveryavas);
export default __webpack_public_path__ + "static/media/hoveryavas.079fd326f49885330794b208df21b5b4.svg";
export { ForwardRef as ReactComponent };